export const HEADER_HEIGHT = 56;
export const DESKTOP_SUBHEADER_HEIGHT = 64;
export const MOBILE_SUBHEADER_HEIGHT = 48;
export const MOBILE_SUBMENU_HEIGHT = 40;
export const DESKTOP_HEADER_TOTAL_HEIGHT = HEADER_HEIGHT + DESKTOP_SUBHEADER_HEIGHT;
export const MOBILE_HEADER_TOTAL_HEIGHT = HEADER_HEIGHT + MOBILE_SUBHEADER_HEIGHT;
